import { useState, useEffect, useRef } from 'react';
import statusService from '../services/statusService';

export type SystemStatusState = 'operational' | 'degraded' | 'unknown';

interface UseSystemStatusReturn {
  status: SystemStatusState;
  lastChecked: Date | null;
}

const POLL_INTERVAL_MS = 60_000;

export function useSystemStatus(): UseSystemStatusReturn {
  const [status, setStatus] = useState<SystemStatusState>('unknown');
  const [lastChecked, setLastChecked] = useState<Date | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const check = async () => {
    try {
      await statusService.checkHealth();
      setStatus('operational');
    } catch {
      setStatus('degraded');
    }
    setLastChecked(new Date());
  };

  useEffect(() => {
    check();
    intervalRef.current = setInterval(check, POLL_INTERVAL_MS);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return { status, lastChecked };
}
